// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_l1-0";
export var fileCarousel = "_l1-2";
export var removeFileButton = "_l1-1";